var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon user",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.133a2.6 2.6 0 1 0-2.58-2.6 2.581 2.581 0 0 0 2.58 2.6zm1.25.8H6.752A3.448 3.448 0 0 0 3.2 14.265a.689.689 0 0 0 .71.667h8.18a.689.689 0 0 0 .71-.667 3.448 3.448 0 0 0-3.553-3.332zm3.55-4.8a2 2 0 1 0-2-2 2 2 0 0 0 2 2zm-8.2 1.4a3.33 3.33 0 0 1 .04-.4 1.81 1.81 0 0 0-.89-.2H2.2A2.271 2.271 0 0 0 0 9.265a.455.455 0 0 0 .44.468h4.988a3.367 3.367 0 0 1-.828-2.2zm-1.4-1.4a2 2 0 1 0-2-2 2 2 0 0 0 2 2zm10.6.8h-1.549a2.085 2.085 0 0 0-.9.206 3.425 3.425 0 0 1 .04.394 3.37 3.37 0 0 1-.829 2.2h4.993A.455.455 0 0 0 16 9.265a2.27 2.27 0 0 0-2.2-2.332z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.1fdb7da3700684d50b1c218c407d07ef.svg";
export { ForwardRef as ReactComponent };